// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"fBGUc","popoverWrapper":"fBGUc","root":"_17wKC"};